import React, {useState} from "react";
import UploadVideo from "./Upload-videoes";
import Uploadfeedback from "./Upload-feedback";
function Videos () {
    const [activeTab, setActiveTab] = useState<"campaign" | "feedback">("campaign");
 return(
    <div className="min-h-screen bg-gray-50 py-8 px-4">
        <div className="max-w-4xl mx-auto">
            <div className="flex mb-6 bg-white rounded-lg shadow p-1">
                <button onClick={() => setActiveTab("campaign")} 
                className={`flex-1 py-2 px-4 rounded-md font-medium transition-all ${activeTab === "campaign" ? "bg-blue-600 text-white" : "text-gray-600 hover:text-gray-900"}`}>
                    Campaign Video
                </button>

                <button onClick={() => setActiveTab("feedback")} 
                className={`flex-1 py-2 px-4 rounded-md font-medium transition-all ${activeTab === "feedback" ? "bg-blue-600 text-white" : "text-gray-600 hover:text-gray-900"}`}>
                    Feedback Video
                </button>

            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
                {activeTab === "campaign" && (
                    <div>
                        <UploadVideo/>
                        </div>
                )}
                {activeTab === "feedback" && (
                    <div>
                        <Uploadfeedback/>
                        </div>
                )} 
            </div>
        </div>
    </div>
 )
}
export default Videos;